import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth";

export function RequireAdmin() {
  const { loading, configured, sessionToken, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="login-wrap">
        <div className="panel panel-pad" role="status" aria-live="polite">
          Checking session…
        </div>
      </div>
    );
  }

  if (!configured) {
    return <Navigate to="/login" replace />;
  }

  if (!sessionToken || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
